import { WeekIntro } from './stories/WeekIntro';
import { TaglineInput } from './stories/TaglineInput';
import { FlowCount } from './stories/FlowCount';
import { ActivityByDay } from './stories/ActivityByDay';
import { PleasantPercentage } from './stories/PleasantPercentage';
import { WorkLifeNetValues } from './stories/WorkLifeNetValues';
import { EnergyLevels } from './stories/EnergyLevels';
import { EnergyTrend } from './stories/EnergyTrend';
import { PleasantnessIntro } from './stories/PleasantnessIntro';
import { PleasantnessTrend } from './stories/PleasantnessTrend';
import { PeakValley } from './stories/PeakValley';
import { RecurringCausesStory, RecurringFeelings } from './RecurringCauses';
import { Support } from './stories/Support';
import { RewardsTally } from './stories/RewardsTally';
import { MostCommonTimes } from './stories/MostCommonTimes';
import { DayStreak } from './stories/DayStreak';
import { HabitHero } from './stories/HabitHero';
import { ReflectionInput } from './stories/ReflectionInput';

export const ComponentMap = {
    intro: WeekIntro,
    weekTitle: TaglineInput,
    flowCount: FlowCount,
    activityByDay: ActivityByDay,
    pleasantPercentage: PleasantPercentage,
    workLifeNetValues: WorkLifeNetValues,
    energyLevels: EnergyLevels,
    energyTrend: EnergyTrend,
    pleasantnessIntro: PleasantnessIntro,
    pleasantnessTrend: PleasantnessTrend,
    peakValley: PeakValley,
    recurringCauses: RecurringCausesStory,
    recurringFeelings: RecurringFeelings,
    support: Support,
    rewardsTally: RewardsTally,
    mostCommonTimes: MostCommonTimes,
    dayStreak: DayStreak,
    habitHeroStreak: HabitHero,
    reflectionInput: ReflectionInput
}